import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './sidejobs.json';

const Sidejobs = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Gig economy, freelancing, and side hustle vocabulary. B2 level grammar, reading, and discussion exercises."
            level="B2"
            title="Side Jobs"
            image="/Images/cellphone1.webp"
            seoTitle="Free English Lesson Plans: Side Jobs"
            seoDescription="Gig economy, freelancing, and side hustle vocabulary. B2 level grammar, reading, and discussion exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Sidejobs;


